import { render } from "./App.vue?vue&type=template&id=47091474"
import script from "./App.ts?vue&type=script&lang=js"
export * from "./App.ts?vue&type=script&lang=js"

import "./tailwind.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/r.hutter/Resilio Sync/_Workspace/git/TitleTool-NG/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__